// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

export const buscarCotasByAptoService = async (
  aptoId: number | undefined | null
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota/apto/${aptoId}`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      const cotasApto = response.data.map((cota: any) => {
        return {
          key: cota.id,
          numeroCota: cota.numeroCota,
          origem: cota.origem === 0 ? "Multicotas" : "Usuário",
          origemApto: cota.origem,
        };
      });

      return cotasApto;
    } catch (error) {
      console.error(error);
    }
  }
};
